import React, { useMemo } from 'react'
import clsx from 'clsx'
import iconsSet from './config'
import * as PropTypes from 'prop-types'

const DEFAULT_ICON_NAME = 'getuniq-rounded'

const sizeMap = {
  s: 24,
  m: 44,
  l: 85,
}

const CreateNetworkIcon = ({
  iconsSet,
  name,
  size = 'l',
  className,
  width,
  rounded = false,
  dark = false,
}) => {
  const widthVal = width ? width : sizeMap[size]
  const heightVal = width ? width : sizeMap[size]

  let iconName = useMemo(
    () => (rounded ? name + '-rounded' : name),
    [name, rounded],
  )

  if (!iconsSet[iconName]) {
    iconName = DEFAULT_ICON_NAME
  }

  const colorScheme =
    !!dark && !!iconsSet[iconName].component['dark'] ? 'dark' : 'white'

  const Component = iconsSet[iconName].component[colorScheme]

  return (
    <Component
      className={clsx('network-icon', className)}
      style={{
        backgroundColor: iconsSet[iconName].backgroundColor[colorScheme],
      }}
      width={widthVal}
      height={heightVal}
    />
  )
}

CreateNetworkIcon.propTypes = {
  iconsSet: PropTypes.object,
  className: PropTypes.string,
  rounded: PropTypes.bool,
  size: PropTypes.oneOf(['s', 'm', 'l']),
  width: PropTypes.number,
  name: PropTypes.string,
  dark: PropTypes.bool,
}

const NetworkIcon = (args) => CreateNetworkIcon({ ...args, iconsSet })

export default NetworkIcon
